// Angular
import { Pipe, PipeTransform } from '@angular/core';
// External
import * as moment from 'moment';

@Pipe({
    name: 'moment'
})

export class MomentPipe implements PipeTransform {

    transform(value: any, ...args: any[]): string {
        if (args.length > 1) {

            if (args[1] === 'unix') {
                return moment.unix(value).format(args[0]);
            }
        }

        return moment(value).format(args[0]);
    }
}
